<template>
  <div class="paymentList">
    <div class="paymentHeader">
      <div class="headerBg"></div>
      <div class="headerGradientBg"></div>
      <div class="headerContainer">
        <div class="containerContent">
          <div class="contentHeader">
            <div class="haderBar"></div>
            <div class="haderBar"></div>
            <div class="haderBar"></div>
          </div>
          <div class="contentTitle">
            تاریخچه
            <span>پرداخت</span>
          </div>
          <div class="contentSubtitle">نمای کلی سفر مالی شما</div>
        </div>
        <div class="containerBox">
          <div class="boxBg"></div>
          <div class="boxContent">
            <div class="boxTitle">
              <div class="titleIcon">
                <i class="fas fa-wallet"></i>
              </div>
              کیف پول
            </div>
            <div class="boxBalance">
              <div class="balanceTitle">موجودی فعلی</div>
              <div class="balanceValue">
                <span class="valueNum">{{
                  formatPrice($store.state.auth.credit)
                }}</span>
                <span class="valueUnit">{{ $store.state.c_set.currency }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="paymentMain">
      <div class="mainContainer">
        <div v-if="loading" class="mainList">
          <Skeletor
            v-for="i in 6"
            :key="i"
            style="
              width: 100%;
              height: 214px;
              border-radius: 16px;
              background: rgb(163, 219, 213);
              margin-bottom: 16px;
            "
          />
        </div>
        <div v-if="!loading && paymentList.length > 0" class="mainList">
          <div
            v-for="(v, i) in paymentList"
            :key="i"
            class="listThumb"
            :class="[v.type == 'inc' ? 'increase' : 'decrease']"
          >
            <div class="thumbInfo">
              <div class="infoIcon">
                <i class="fas fa-arrow-down"></i>
              </div>
              <div class="infoContent">
                <div class="contentTitle">{{ v.type_fn }} اعتبار</div>
                <div class="contentDate">{{ v.created_at }}</div>
              </div>
            </div>
            <div class="thumbValue">
              <div class="valueChanged">{{ formatPrice(v.amount) }} تومان</div>
              <div class="valueOld">
                <span>موجودی قبلی:</span>
                <span>{{ formatPrice(v.old_credit) }} تومان</span>
              </div>
              <div class="valueNew">
                <span>موجودی جدید:</span>
                <span>{{ formatPrice(v.new_credit) }} تومان</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!loading && paymentList.length == 0" class="noResult">
          <div class="noResultThumb">
            <div class="noResultPic">
              <img :src="publicPath + 'img/notfound.png'" alt="Alt text" />
            </div>
            <div class="noResult">داده‌ای یافت نشد!</div>
          </div>
        </div>
        <div
          class="loadeMoreLoader"
          v-if="loadeMoreLoading && paymentList.length > 0"
        >
          <span class="custom-loader"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeletor } from "vue-skeletor";

export default {
  name: "paymentList",
  components: {
    Skeletor,
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      page: 1,
      per_page: 8,
      paymentList: [],
      loading: false,
      loadeMore: true,
      loadeMoreLoading: false,
    };
  },
  methods: {
    getPayemntListHandler(params) {
      let self = this;
      this.loadeMore = true;
      this.loadeMoreLoading = true;
      this.page++;

      if (params == "first") {
        this.paymentList = [];
        this.page = 1;
        this.loading = true;
      }

      this.helperPost("credit-list", {
        page: this.page,
        per_page: this.per_page,
      }).then((response) => {
        if (response.data.result == 1) {
          self.paymentList = self.paymentList.concat(response.data.data.list);

          if (response.data.data.total_page == self.page) {
            self.loadeMore = false;
          }

          self.loading = false;
          self.loadeMoreLoading = false;
        }
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(",", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    handleWindowScroll() {
      let windowSize = window.innerWidth;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      if (windowSize > 1000) {
        if (scrollTop + windowHeight + 686.6 >= fullHeight) {
          if (this.loadeMore && !this.loadeMoreLoading) {
            this.getPayemntListHandler();
          }
        }
      } else {
        if (scrollTop + windowHeight + 100 >= fullHeight) {
          if (this.loadeMore && !this.loadeMoreLoading) {
            this.getPayemntListHandler();
          }
        }
      }
    },
  },
  mounted() {
    this.getPayemntListHandler("first");
    window.addEventListener("scroll", this.handleWindowScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleWindowScroll);
  },
};
</script>

<style scoped lang="scss">
.paymentList {
  width: 100%;
  background: #f9fafb;
  padding-top: 70px;

  .paymentHeader {
    position: relative;
    width: 100%;
    padding-top: 4rem;
    padding-bottom: 4rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow: hidden;
    background-image: linear-gradient(to bottom right, #0096c7, #023e8a);

    .headerBg {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      opacity: 0.3;
      background-image: url("../assets/img/paymentBg.jpg");
      background-position: center;
      background-size: cover;
      z-index: 0;
    }

    .headerGradientBg {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to right,
        rgb(0 150 199 / 0.9),
        rgb(2 62 138 / 0.9)
      );
      z-index: 1;
    }

    .headerContainer {
      position: relative;
      z-index: 2;
      width: 100%;
      max-width: 56rem;
      margin-left: auto;
      margin-right: auto;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      align-items: center;
      gap: 3rem;

      .containerContent {
        width: 100%;

        .contentHeader {
          display: flex;
          align-items: center;
          margin-bottom: 8px;

          .haderBar {
            &:first-child {
              width: 5rem;
              height: 0.25rem;
              border-radius: 9999px;
              background: rgb(96 165 250);
            }
            &:nth-child(2) {
              width: 1.5rem;
              height: 0.25rem;
              border-radius: 9999px;
              background: rgb(147 197 253);
              margin-left: 12px;
            }
            &:last-child {
              width: 0.75rem;
              height: 0.25rem;
              border-radius: 9999px;
              background: rgb(191 219 254);
              margin-left: 12px;
            }
          }
        }

        .contentTitle {
          margin-top: 16px;
          color: #fff;
          line-height: 1.25;
          font-family: "yekan", sans-serif;
          font-weight: 800;
          text-align: right;
          font-size: 2.35rem;
          span {
            display: block;
          }
        }

        .contentSubtitle {
          margin-top: 16px;
          color: rgb(191 219 254);
          font-size: 1.25rem;
          line-height: 1.75rem;
        }
      }

      .containerBox {
        width: 100%;
        position: relative;

        .boxBg {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          border-radius: 24px;
          background: linear-gradient(
            to right,
            rgb(96 165 250 / 0.2),
            rgb(147 197 253 / 0.2)
          );
          filter: blur(24px);
          z-index: 0;
        }

        .boxContent {
          backdrop-filter: blur(24px);
          padding: 2rem;
          background: linear-gradient(
            to bottom right,
            rgb(255 255 255 / 0.1),
            rgb(255 255 255 / 0.05)
          );
          border: 1px solid rgb(255 255 255 / 0.1);
          border-radius: 1.5rem;
          position: relative;
          z-index: 1;

          .boxTitle {
            display: flex;
            align-items: center;
            margin-bottom: 1.5rem;
            gap: 8px;
            color: rgb(219 234 254);
            font-size: 1rem;

            .titleIcon {
              width: 2.5rem;
              height: 2.5rem;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 0.75rem;
              background: rgb(96 165 250 / 0.2);

              i {
                color: rgb(147 197 253);
              }
            }
          }

          .boxBalance {
            .balanceTitle {
              color: rgb(191 219 254);
              font-size: 0.875rem;
              line-height: 1.25rem;
            }

            .balanceValue {
              display: flex;
              align-items: flex-end;
              .valueNum {
                font-family: "yekan", sans-serif;
                font-weight: 800;
                font-size: 1.75rem;
                color: #fff;
                margin-left: 6px;
              }

              .valueUnit {
                display: block;
                font-size: 1rem;
                color: #fff;
                margin-bottom: 8px;
              }
            }
          }
        }
      }
    }
  }

  .paymentMain {
    padding: 2rem 0;

    .mainContainer {
      width: 90%;
      max-width: 56rem;
      margin-left: auto;
      margin-right: auto;

      .mainList {
        width: 100%;

        .listThumb {
          width: 100%;
          background: #fff;
          border: 1px solid rgb(243 244 246);
          border-radius: 16px;
          padding: 24px;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          display: flex;
          align-items: center;
          justify-content: space-between;

          &:not(:last-child) {
            margin-bottom: 16px;
          }

          &:hover {
            box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
              0 2px 4px -2px rgb(0 0 0 / 0.1);
          }

          &.increase {
            .thumbInfo {
              .infoIcon {
                background: rgb(220 252 231);
                color: rgb(22 163 74);

                i {
                  transform: rotate(180deg);
                }
              }
            }
            .thumbValue {
              .valueChanged {
                color: rgb(22 163 74);
              }
            }
          }

          &.decrease {
            .thumbInfo {
              .infoIcon {
                background: rgb(252, 220, 220);
                color: #f00;
              }
            }
            .thumbValue {
              .valueChanged {
                color: #f00;
              }
            }
          }

          .thumbInfo {
            display: flex;
            align-items: center;
            gap: 8px;

            .infoIcon {
              width: 48px;
              height: 48px;
              border-radius: 9999px;
              display: flex;
              align-items: center;
              justify-content: center;

              i {
                font-size: 1.35rem;
              }
            }

            .infoContent {
              .contentTitle {
                font-family: "iranyekanB", sans-serif;
                font-size: 1.1rem;
                margin-bottom: 3px;
              }

              .contentDate {
                font-size: 0.95rem;
                color: rgb(156 163 175);
              }
            }
          }

          .thumbValue {
            .valueChanged {
              font-family: "iranyekanB", sans-serif;
              font-size: 1rem;
              margin-bottom: 4px;
            }

            .valueOld {
              font-size: 0.8rem;
              color: rgb(107 114 128);
              margin-bottom: 4px;
            }

            .valueNew {
              font-size: 0.8rem;
              color: rgb(55 65 81);
            }
          }
        }
      }
    }
  }
}

.dark {
  .paymentList {
    background: #1e262f;
    color: #fff;

    .paymentMain {
      .mainContainer {
        .mainList {
          .listThumb {
            background: #101a23;
            box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.05);
            border: 1px solid rgb(61, 61, 61);
            color: #fff;

            &:hover {
              box-shadow: 0 4px 6px -1px rgb(255 255 255 / 0.1),
                0 2px 4px -2px rgb(255 255 255 / 0.1);
            }

            &.increase {
              .thumbInfo {
                .infoIcon {
                  background: rgb(44, 58, 49);
                  color: rgb(22 163 74);

                  i {
                    transform: rotate(180deg);
                  }
                }
              }
              .thumbValue {
                .valueChanged {
                  color: rgb(22 163 74);
                }
              }
            }

            &.decrease {
              .thumbInfo {
                .infoIcon {
                  background: rgb(58, 44, 44);
                  color: #f00;
                }
              }
              .thumbValue {
                .valueChanged {
                  color: #f00;
                }
              }
            }

            .thumbValue {
              .valueOld {
                color: rgb(148, 157, 173);
              }

              .valueNew {
                color: rgb(215, 230, 254);
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 750px) {
  .paymentList {
    min-height: calc(100vh - 60px);
    padding-top: 0;
    padding-bottom: 82px;

    .paymentHeader {
      padding: 2rem 1rem;
      .headerContainer {
        grid-template-columns: 100%;
        gap: 1.25rem;

        .containerContent {
          .contentTitle {
            font-size: 1.75rem;
            span {
              display: inline;
            }
          }

          .contentSubtitle {
            margin-top: 8px;
          }
        }

        .containerBox {
          display: none;
        }
      }
    }

    .paymentMain {
      .mainContainer {
        .mainList {
          .listThumb {
            flex-direction: column;
            gap: 8px;
            align-items: flex-start;

            .thumbInfo {
              width: 100%;
              flex-direction: row-reverse;
              justify-content: space-between;
            }

            .thumbValue {
              width: 100%;
              .valueChanged {
                font-size: 1.15rem;
                margin-bottom: 8px;
              }
              .valueOld,
              .valueNew {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 0.85rem;
              }
            }
          }
        }
      }
    }
  }
}

.noResultThumb {
  padding: 42px 0;
  .noResultPic {
    img {
      max-width: 90%;
      height: 280px;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .noResult {
    text-align: center;
    font-size: 0.95rem;
  }
}
</style>
